module.exports = __webpack_public_path__ + "img/200.46a2386b.jpg";